import { useEffect, useState } from 'react'
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore'
import { db } from '@/config/firebase'
import type { ProjectDoc } from '@/types/project'

export interface ProjectRecord extends ProjectDoc {
  id: string
}

interface ProjectsState {
  projects: ProjectRecord[]
  loading: boolean
  error: string | null
}

/** Realtime list of all projects, newest first (admin view — firestore.rules). */
export function useProjects(): ProjectsState {
  const [state, setState] = useState<ProjectsState>({ projects: [], loading: true, error: null })

  useEffect(() => {
    const projectsQuery = query(collection(db, 'projects'), orderBy('startDate', 'desc'))
    const unsubscribe = onSnapshot(
      projectsQuery,
      (snapshot) => {
        const projects = snapshot.docs.map((docSnap) => ({
          id: docSnap.id,
          ...(docSnap.data() as ProjectDoc),
        }))
        setState({ projects, loading: false, error: null })
      },
      (error) => {
        setState({ projects: [], loading: false, error: error.message })
      },
    )
    return unsubscribe
  }, [])

  return state
}
